module.exports = __webpack_public_path__ + "static/img/banner-18-sept-jepang.f0f914a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-jepang.png
// module id = vRxY
// module chunks = 1